const stage_dict = {"undergraduate": "a undergraduate student", "graduate": "a graduate student", "postdoc": "postdoc", "faculty": "professor", "industry": "working"};

export default stage_dict;